/**
 * `client.catalog` (#1044): one namespace for priced catalog lines. `list` is the
 * unified read; the vertical methods hit the unchanged /menu* and /services*
 * routes, so responses and caching are byte-identical to the deprecated
 * top-level methods they replace.
 */
export class CatalogClient {
    vertical;
    request;
    constructor(vertical, request) {
        this.vertical = vertical;
        this.request = request;
    }
    /** GET /v1/sites/{slug}/catalog. Public unless `includeArchived` (staff, sends the token). */
    async list(slug, options = {}) {
        const params = new URLSearchParams();
        if (options.kind)
            params.set("kind", options.kind);
        const staff = options.includeArchived === true;
        if (staff)
            params.set("includeArchived", "true");
        const query = params.toString();
        return this.request("GET", `/v1/sites/${encodeURIComponent(slug)}/catalog${query ? `?${query}` : ""}`, undefined, staff);
    }
    menu = (...args) => this.vertical.getMenu(...args);
    upsertMenuCategory = (...args) => this.vertical.upsertMenuCategory(...args);
    upsertMenuItem = (...args) => this.vertical.upsertMenuItem(...args);
    patchMenuItem = (...args) => this.vertical.patchMenuItem(...args);
    patchMenuCategory = (...args) => this.vertical.patchMenuCategory(...args);
    deleteMenuItem = (...args) => this.vertical.deleteMenuItem(...args);
    deleteMenuCategory = (...args) => this.vertical.deleteMenuCategory(...args);
    services = (...args) => this.vertical.listServices(...args);
    createService = (...args) => this.vertical.createService(...args);
    updateService = (...args) => this.vertical.updateService(...args);
    archiveService = (...args) => this.vertical.archiveService(...args);
    restoreService = (...args) => this.vertical.restoreService(...args);
}
/** A /services row as a canonical service-kind line. */
export function catalogItemFromService(s) {
    return {
        id: s.id,
        kind: "service",
        categoryId: "",
        category: s.category ?? "",
        name: s.name,
        description: s.description ?? "",
        priceCents: s.priceCents,
        sort: s.sortOrder,
        available: true,
        archived: s.archived,
        allergens: "",
        durationMinutes: s.durationMinutes ?? 0,
        imageUrl: s.imageUrl ?? "",
    };
}
/** A public /menu body as canonical menu-kind lines (category label filled in). */
export function catalogItemsFromMenu(menu) {
    return menu.categories.flatMap((cat) => cat.items.map((item) => ({
        id: item.id,
        kind: "menu",
        categoryId: cat.id,
        category: cat.name,
        name: item.name,
        description: item.description,
        priceCents: item.priceCents,
        sort: item.sort,
        available: item.available ?? true,
        archived: false,
        allergens: item.allergens ?? "",
        durationMinutes: 0,
        imageUrl: "",
    })));
}
//# sourceMappingURL=catalog.js.map